const panelConstants = {
  PROCEDURES: 'PROCEDURES',
  LIVEDATA: 'LIVEDATA',
  SPECIES: 'SPECIES',
  LABBOOK: 'LABBOOK',
  PRESETS: 'PRESETS',
};

export default Object.freeze(panelConstants);
